module.exports = __webpack_public_path__ + "img/win.5f56d03d.svg";